import {
  PURCHASE_DRAFT_LIST,
  PURCHASE_DRAFT_LIST_SUCCESS,
  PURCHASE_DRAFT_LIST_FAIL,
  PURCHASE_DRAFT_SEARCH,
  PURCHASE_DRAFT_SEARCH_SUCCESS,
  PURCHASE_DRAFT_SEARCH_FAIL,
  PURCHASE_DRAFT_DATA,
  PURCHASE_DRAFT_DATA_SUCCESS,
  PURCHASE_DRAFT_DATA_FAIL,
  PURCHASE_DRAFT_CREATE,
  PURCHASE_DRAFT_CREATE_SUCCESS,
  PURCHASE_DRAFT_CREATE_FAIL,
  PURCHASE_DRAFT_UPDATE,
  PURCHASE_DRAFT_UPDATE_SUCCESS,
  PURCHASE_DRAFT_UPDATE_FAIL,
  PURCHASE_DRAFT_DELETE,
  PURCHASE_DRAFT_DELETE_SUCCESS,
  PURCHASE_DRAFT_DELETE_FAIL,
  PURCHASE_DRAFT_CONVERT_TO_PURCHASE,
  PURCHASE_DRAFT_CONVERT_TO_PURCHASE_SUCCESS,
  PURCHASE_DRAFT_CONVERT_TO_PURCHASE_FAIL,
  PURCHASE_DRAFT_STATUS_LIST,
  PURCHASE_DRAFT_STATUS_LIST_SUCCESS,
  PURCHASE_DRAFT_STATUS_LIST_FAIL,
  PURCHASE_DRAFT_STATUS_DATA,
  PURCHASE_DRAFT_STATUS_DATA_SUCCESS,
  PURCHASE_DRAFT_STATUS_DATA_FAIL,
  PURCHASE_DRAFT_STATUS_CREATE,
  PURCHASE_DRAFT_STATUS_CREATE_SUCCESS,
  PURCHASE_DRAFT_STATUS_CREATE_FAIL,
  PURCHASE_DRAFT_STATUS_UPDATE,
  PURCHASE_DRAFT_STATUS_UPDATE_SUCCESS,
  PURCHASE_DRAFT_STATUS_UPDATE_FAIL,
  PURCHASE_DRAFT_STATUS_DELETE,
  PURCHASE_DRAFT_STATUS_DELETE_SUCCESS,
  PURCHASE_DRAFT_STATUS_DELETE_FAIL,
} from "./actionType";

const initialState = {
  purchaseDraftList: [],
  purchaseDraftListLoading: false,
  purchaseDraftListError: null,
  purchaseDraftSearch: [],
  purchaseDraftSearchLoading: false,
  purchaseDraftSearchError: null,
  purchaseDraftData: {},
  purchaseDraftDataLoading: false,
  purchaseDraftDataError: null,
  purchaseDraftCreate: {},
  purchaseDraftCreateLoading: false,
  purchaseDraftCreateError: null,
  purchaseDraftUpdate: {},
  purchaseDraftUpdateLoading: false,
  purchaseDraftUpdateError: null,
  purchaseDraftDelete: {},
  purchaseDraftDeleteLoading: false,
  purchaseDraftDeleteError: null,
  purchaseDraftConvertToPurchase: {},
  purchaseDraftConvertToPurchaseLoading: false,
  purchaseDraftConvertToPurchaseError: null,
  purchaseDraftStatusList: [],
  purchaseDraftStatusListLoading: false,
  purchaseDraftStatusListError: null,
  purchaseDraftStatusData: {},
  purchaseDraftStatusDataLoading: false,
  purchaseDraftStatusDataError: null,
  purchaseDraftStatusCreate: {},
  purchaseDraftStatusCreateLoading: false,
  purchaseDraftStatusCreateError: null,
  purchaseDraftStatusUpdate: {},
  purchaseDraftStatusUpdateLoading: false,
  purchaseDraftStatusUpdateError: null,
  purchaseDraftStatusDelete: {},
  purchaseDraftStatusDeleteLoading: false,
  purchaseDraftStatusDeleteError: null,
};

const PurchaseDraft = (state = initialState, action) => {
  switch (action.type) {
    case PURCHASE_DRAFT_LIST:
      return {
        ...state,
        purchaseDraftListLoading: true,
        purchaseDraftListError: null,
      };
    case PURCHASE_DRAFT_LIST_SUCCESS:
      return {
        ...state,
        purchaseDraftList: action.payload,
        purchaseDraftListLoading: false,
        purchaseDraftListError: null,
      };
    case PURCHASE_DRAFT_LIST_FAIL:
      return {
        ...state,
        purchaseDraftListLoading: false,
        purchaseDraftListError: action.payload,
      };
    case PURCHASE_DRAFT_SEARCH:
      return {
        ...state,
        purchaseDraftSearchLoading: true,
        purchaseDraftSearchError: null,
      };
    case PURCHASE_DRAFT_SEARCH_SUCCESS:
      return {
        ...state,
        purchaseDraftSearch: action.payload,
        purchaseDraftSearchLoading: false,
        purchaseDraftSearchError: null,
      };
    case PURCHASE_DRAFT_SEARCH_FAIL:
      return {
        ...state,
        purchaseDraftSearchLoading: false,
        purchaseDraftSearchError: action.payload,
      };
    case PURCHASE_DRAFT_DATA:
      return {
        ...state,
        purchaseDraftDataLoading: true,
        purchaseDraftDataError: null,
      };
    case PURCHASE_DRAFT_DATA_SUCCESS:
      return {
        ...state,
        purchaseDraftData: action.payload,
        purchaseDraftDataLoading: false,
        purchaseDraftDataError: null,
      };
    case PURCHASE_DRAFT_DATA_FAIL:
      return {
        ...state,
        purchaseDraftDataLoading: false,
        purchaseDraftDataError: action.payload,
      };
    case PURCHASE_DRAFT_CREATE:
      return {
        ...state,
        purchaseDraftCreateLoading: true,
        purchaseDraftCreateError: null,
      };
    case PURCHASE_DRAFT_CREATE_SUCCESS:
      return {
        ...state,
        purchaseDraftCreate: action.payload,
        purchaseDraftCreateLoading: false,
        purchaseDraftCreateError: null,
      };
    case PURCHASE_DRAFT_CREATE_FAIL:
      return {
        ...state,
        purchaseDraftCreateLoading: false,
        purchaseDraftCreateError: action.payload,
      };
    case PURCHASE_DRAFT_UPDATE:
      return {
        ...state,
        purchaseDraftUpdateLoading: true,
        purchaseDraftUpdateError: null,
      };
    case PURCHASE_DRAFT_UPDATE_SUCCESS:
      return {
        ...state,
        purchaseDraftUpdate: action.payload,
        purchaseDraftUpdateLoading: false,
        purchaseDraftUpdateError: null,
      };
    case PURCHASE_DRAFT_UPDATE_FAIL:
      return {
        ...state,
        purchaseDraftUpdateLoading: false,
        purchaseDraftUpdateError: action.payload,
      };
    case PURCHASE_DRAFT_DELETE:
      return {
        ...state,
        purchaseDraftDeleteLoading: true,
        purchaseDraftDeleteError: null,
      };
    case PURCHASE_DRAFT_DELETE_SUCCESS:
      return {
        ...state,
        purchaseDraftDelete: action.payload,
        purchaseDraftDeleteLoading: false,
        purchaseDraftDeleteError: null,
      };
    case PURCHASE_DRAFT_DELETE_FAIL:
      return {
        ...state,
        purchaseDraftDeleteLoading: false,
        purchaseDraftDeleteError: action.payload,
      };
    case PURCHASE_DRAFT_CONVERT_TO_PURCHASE:
      return {
        ...state,
        purchaseDraftConvertToPurchaseLoading: true,
        purchaseDraftConvertToPurchaseError: null,
      };
    case PURCHASE_DRAFT_CONVERT_TO_PURCHASE_SUCCESS:
      return {
        ...state,
        purchaseDraftConvertToPurchase: action.payload,
        purchaseDraftConvertToPurchaseLoading: false,
        purchaseDraftConvertToPurchaseError: null,
      };
    case PURCHASE_DRAFT_CONVERT_TO_PURCHASE_FAIL:
      return {
        ...state,
        purchaseDraftConvertToPurchaseLoading: false,
        purchaseDraftConvertToPurchaseError: action.payload,
      };
    case PURCHASE_DRAFT_STATUS_LIST:
      return {
        ...state,
        purchaseDraftStatusListLoading: true,
        purchaseDraftStatusListError: null,
      };
    case PURCHASE_DRAFT_STATUS_LIST_SUCCESS:
      return {
        ...state,
        purchaseDraftStatusList: action.payload,
        purchaseDraftStatusListLoading: false,
        purchaseDraftStatusListError: null,
      };
    case PURCHASE_DRAFT_STATUS_LIST_FAIL:
      return {
        ...state,
        purchaseDraftStatusListLoading: false,
        purchaseDraftStatusListError: action.payload,
      };
    case PURCHASE_DRAFT_STATUS_DATA:
      return {
        ...state,
        purchaseDraftStatusDataLoading: true,
        purchaseDraftStatusDataError: null,
      };
    case PURCHASE_DRAFT_STATUS_DATA_SUCCESS:
      return {
        ...state,
        purchaseDraftStatusData: action.payload,
        purchaseDraftStatusDataLoading: false,
        purchaseDraftStatusDataError: null,
      };
    case PURCHASE_DRAFT_STATUS_DATA_FAIL:
      return {
        ...state,
        purchaseDraftStatusDataLoading: false,
        purchaseDraftStatusDataError: action.payload,
      };
    case PURCHASE_DRAFT_STATUS_CREATE:
      return {
        ...state,
        purchaseDraftStatusCreateLoading: true,
        purchaseDraftStatusCreateError: null,
      };
    case PURCHASE_DRAFT_STATUS_CREATE_SUCCESS:
      return {
        ...state,
        purchaseDraftStatusCreate: action.payload,
        purchaseDraftStatusCreateLoading: false,
        purchaseDraftStatusCreateError: null,
      };
    case PURCHASE_DRAFT_STATUS_CREATE_FAIL:
      return {
        ...state,
        purchaseDraftStatusCreateLoading: false,
        purchaseDraftStatusCreateError: action.payload,
      };
    case PURCHASE_DRAFT_STATUS_UPDATE:
      return {
        ...state,
        purchaseDraftStatusUpdateLoading: true,
        purchaseDraftStatusUpdateError: null,
      };
    case PURCHASE_DRAFT_STATUS_UPDATE_SUCCESS:
      return {
        ...state,
        purchaseDraftStatusUpdate: action.payload,
        purchaseDraftStatusUpdateLoading: false,
        purchaseDraftStatusUpdateError: null,
      };
    case PURCHASE_DRAFT_STATUS_UPDATE_FAIL:
      return {
        ...state,
        purchaseDraftStatusUpdateLoading: false,
        purchaseDraftStatusUpdateError: action.payload,
      };
    case PURCHASE_DRAFT_STATUS_DELETE:
      return {
        ...state,
        purchaseDraftStatusDeleteLoading: true,
        purchaseDraftStatusDeleteError: null,
      };
    case PURCHASE_DRAFT_STATUS_DELETE_SUCCESS:
      return {
        ...state,
        purchaseDraftStatusDelete: action.payload,
        purchaseDraftStatusDeleteLoading: false,
        purchaseDraftStatusDeleteError: null,
      };
    case PURCHASE_DRAFT_STATUS_DELETE_FAIL:
      return {
        ...state,
        purchaseDraftStatusDeleteLoading: false,
        purchaseDraftStatusDeleteError: action.payload,
      };
    default:
      return state;
  }
};
export default PurchaseDraft;
